/**
 * Reserve UI Components
 *
 * 予約関連の共通UIコンポーネント
 * - Alert系コンポーネント（Error, Warning, Success）
 * - Description Button
 * - Alert Title
 */
import { styled } from '@this/constants/themes';
import Alert from '@material-ui/lab/Alert';
import { AlertTitle } from '@material-ui/lab';

export const StyledReserveErrorAlert = styled(Alert)`
  background-color: #f6eae6;
  color: ${props => props.theme.redColor};
  margin-bottom: 20px;
  .MuiAlert-message {
    width: 100%;
  }
`;

export const StyledReserveWarningAlert = styled(Alert)`
  background-color: #fbf6e7;
  color: ${props => props.theme.redColor};
  margin-bottom: 20px;
  .MuiAlert-message {
    width: 100%;
  }
`;

export const StyledReserveSuccessAlert = styled(Alert)`
  background-color: #edf6fa;
  color: #48a4c8;
  margin-bottom: 20px;
  .MuiAlert-message {
    width: 100%;
  }
`;

export const StyledDescriptionButton = styled.div`
  cursor: pointer;
  width: 50px;
  margin-left: auto;
  display: flex;
  justify-content: center;
`;

export const StyledAlertTitle = styled(AlertTitle)`
  font-weight: 700;
  margin-top: 1px;
`;
